import styled from '@emotion/styled'

import { typo } from '../../../../libs/common/style/cssStyles'

const LoadingModalStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;

  width: 360px;
  height: 160px;

  background: var(--Colors-White, #fff);
  border-radius: var(--Radius-M, 12px);
  padding: 36px 42px;

  box-shadow: 0px 8px 24px 0px rgba(41, 42, 43, 0.08);

  .loading-modal-layer {
    display: flex;
    align-items: center;
    justify-content: center;

    width: 45px;
    height: 45px;
  }

  .loading-modal-message {
    color: var(--Colors-Gray-900);
    ${typo.body02};
    text-align: center;
  }
`

export default LoadingModalStyled
